// @flow

import Vue from 'vue'
import { PostHog } from 'posthog-js'

import { logger, getQuery } from '../common'
import { i18n } from '../common/plugins/i18n'
import posthog from '../common/plugins/posthog'

import './styles/variables.css'

import Main from './components/Main/Main.vue'

Vue.config.devtools = false
Vue.config.productionTip = false
Vue.config.errorHandler = (err) => logger.error(err)

export function createApp (store: any, posthogInstance?: typeof PostHog, initialProps?: any): any {
  Vue.use(posthog, posthogInstance)
  const showCloseButton = (getQuery('show_close_button') === 'true')

  return new Vue({
    el: '#app',
    i18n: i18n,
    render: function (createElement) {
      return createElement(Main, {
        props: {
          showCloseButton: showCloseButton,
          ...(initialProps || {})
        }
      })
    },
    store: store
  })
}
